import { render, staticRenderFns } from "./treePurchase.vue?vue&type=template&id=7f1beeb6&scoped=true"
import script from "./treePurchase.vue?vue&type=script&lang=js"
export * from "./treePurchase.vue?vue&type=script&lang=js"
import style0 from "./treePurchase.vue?vue&type=style&index=0&id=7f1beeb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1beeb6",
  null
  
)

export default component.exports